import { builder } from '@builder.io/react';

// used for builder init
const BUILDER_API = process.env.NEXT_PUBLIC_BUILDER_API;

if (BUILDER_API) builder.init(BUILDER_API);

export * from './Form/register';
export * from './Button/register';
export * from './Header/register';
export * from './Hero/register';
export * from './SecondaryHero/register';
export * from './LogoBar/register';
export * from './Layout/register';
export * from './ThreeColumn/register';
export * from './CopyAndImage/register';
export * from './Accordion/register';
export * from './CtaSection/register';
export * from './IconList/register';
export * from './SingleForm/register';
export * from './customMenus';
export * from './MainHeader/register';
export * from './ListAndImage/register';
export * from './TrapezoidHero/register';
export * from './Listicle/register';
export * from './ContactUs/register';
export * from './BragBar/register';
